<template>
  <pl-dialog :disableOutsideClick="true" size="confirm_size" title="Start Discussion" @close="$emit('close')">
    <div class="flex flex-col h-full py-4 px-6">
      <div class="flex flex-grow h-full mb-5">
        <div class="text-gray-700">
          Starting the discussion will <span class="font-medium">allow students</span> to begin tapping in to
          speak. Engagement <span class="font-medium">statistics will be tracked until</span> the discussion is
          stopped. You can <span class="font-medium">start and stop</span> the
          discussion at any time!
        </div>
      </div>
      <div class="flex items-center justify-between space-x-4">
        <button
          @click="show_start_discussion = false"
          class="w-full bg-gray-100 border border-solid border-gray-200 rounded-md py-2 px-4 text-gray-700"
        >
          Cancel
        </button>
        <button
          class="flex justify-center items-center space-x-2 w-full bg-green rounded-md border border-solid border-green-600 py-2 px-4 text-white"
          @click="handleStartDiscussion()"
        >
          <span>Start Discussion</span>
          <div v-if="isStarting" class="loader"></div>
        </button>
      </div>
    </div>
  </pl-dialog>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';

  export default Vue.extend({
    data() {
      return {
       isStarting: false,
      };
    },
    computed: {
      ...mapGetters(['getCurrentDiscussion']),
    },
    methods: {
      handleStartDiscussion: async function() {
        this.isStarting = true;
        await this.$store.dispatch('startLiveDiscussion', this.getCurrentDiscussion.id).then(({ data }) => {
          if (this.audio_is_enabled && !this.getCurrentDiscussion.teacher_tapped_in_id && data.is_live) {
            EventBus.$emit('teacher-start-audio-call');
            EventBus.$emit('joiningAudioDiscussion');
          }
          EventBus.$emit('restartLD');
        });
        this.$emit('close');
      } 
    }
  });
</script>


// WEBPACK FOOTER //
// MDStartDiscussion.vue?4557900c